// removed by extract-text-webpack-plugin
module.exports = {"header":"style__header___3ERKF","page":"style__page___1hQko","title":"style__title___dImxN","subTitle":"style__subTitle___bWZ9T","label":"style__label___3hoTg","errorContainer":"style__errorContainer___2dk_a"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/business/ui/screens/send-link-by-sms/style.css
// module id = 1090
// module chunks = 0